declare const I18n;

import React, { useEffect, useState } from "react";
import Modal from "./modal";
import DOMPurify from "dompurify/dist/purify.min";


type WomenInStemModalProps = {
  name: string;
  skillSlug: string;
  info: string;
  pointsRequired: number;
  learnMoreUrl?: string;
  imageUrl: string;
  isNew: boolean;
  show: boolean;
  hasMultiple?: boolean;
  disablePrev?: boolean;
  disableNext?: boolean;
  onNext?: () => void;
  onPrev?: () => void;
  closeModal?: () => void;
};

const WomenInStemModal: React.FC<WomenInStemModalProps> = ({
  name,
  skillSlug,
  info,
  pointsRequired,
  learnMoreUrl,
  imageUrl,
  isNew,
  show,
  hasMultiple,
  disablePrev,
  disableNext,
  onNext,
  onPrev,
  closeModal
}) => {
  const iconMap: Record<string, string> = {
    growth_mindset: "/BrainBuilder.svg",
    creativity: "/CreativeSpark.svg",
    critical_thinking: "/PuzzleSolver.svg",
    communication: "/SignalBoost.svg",
    collaboration: "/SyncSquad.svg",
    global_citizenship: "/WorldCitizen.svg",
  };

  const iconPath = iconMap[skillSlug];
  const cleanedName = name.replace(/\s*[\(\[].*?[\)\]]\s*/g, "").trim();
  const wikiName = cleanedName.replace(/\s+/g, "_");
  const lang = I18n.locale === "fr" ? "fr" : "en";
  const wikiUrl = `https://${lang}.wikipedia.org/wiki/${encodeURIComponent(wikiName)}`

  const finalLearnMoreUrl = learnMoreUrl? learnMoreUrl : wikiUrl

  const [photoUrl, setPhotoUrl] = useState<string>("/blackout.svg");

  useEffect(() => {

    const img = new Image();
    img.src = imageUrl;

    img.onload = () => setPhotoUrl(imageUrl);
    img.onerror = () => setPhotoUrl("/blackout.svg");
  }, [imageUrl]);

  return (
    <Modal
      show={show}
      onClose={closeModal}
    >
      <>
        <button
          className="steam-close-btn"
          onClick={closeModal}
        >
          <i className="fa-solid fa-xmark"></i>
        </button>
        {hasMultiple && (
          <>
            {!disablePrev && (
              <button className="steam-nav-btn steam-nav-btn--left" onClick={onPrev} disabled={disablePrev}>
                <i className="fa-solid fa-circle-chevron-left"></i>
              </button>

            )}
            {!disableNext && (
              <button className="steam-nav-btn steam-nav-btn--right" onClick={onNext} disabled={disableNext}>
                <i className="fa-solid fa-circle-chevron-right"></i>
              </button>
            )}
          </>
        )}

        <div style={{ display: "flex", alignItems: "center", gap: "3rem" }}>
          <div
            className="skill-card skill-card--unlocked"
            style={
              {
                "--skill-photo": `url('${photoUrl}')`,
                flexBasis: "40%",
                minWidth: "17.5rem",
                maxWidth: "20%"
              } as React.CSSProperties
            }
          >
            <p className="skill-card__name skill-card-info__unlocked">{name}</p>
          </div>
          <div>
            {isNew && (
              <h3 className="skills-heading__title">{I18n.t(`views.achievements.modal.women_in_steam.unlocked_message`)}</h3>
            )}
            <div style={{ display: "flex", alignItems: "center", gap: "1rem", paddingTop: "2rem" }}>
              {iconPath && (
                <img
                  src={iconPath}
                  className="skills-heading__icon"
                  width={150}
                  height={150}
                  alt={`${skillSlug} icon`}
                />
              )}
              <div>
                <p className="skills-heading__title__white">
                  {I18n.t(`models.skills.attributes.${skillSlug}`)}
                </p>
                <p>{I18n.t(`views.achievements.modal.women_in_steam.points`, { points: pointsRequired })}</p>
              </div>
            </div>
          </div>
        </div>
        {info && (
          <div
            className="steam-info"
            dangerouslySetInnerHTML={{
              __html: DOMPurify.sanitize(info),
            }}
          />
        )}
        <div style={{ paddingTop: "2rem" }}>
          <a href={finalLearnMoreUrl} target="_blank"
            rel="noopener noreferrer" >{I18n.t(`views.achievements.modal.women_in_steam.learn_more`, { name: cleanedName })}</a>
        </div>
      </>

    </Modal>
  );
};

export default WomenInStemModal;
